import { render, staticRenderFns } from "./productTag.vue?vue&type=template&id=1e5e3f66&scoped=true"
import script from "./productTag.vue?vue&type=script&lang=js"
export * from "./productTag.vue?vue&type=script&lang=js"
import style0 from "./productTag.vue?vue&type=style&index=0&id=1e5e3f66&prod&lang=css"
import style1 from "./productTag.vue?vue&type=style&index=1&id=1e5e3f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5e3f66",
  null
  
)

export default component.exports